module.exports = "/virtual-football-league/img/amblems/right/logos/ALAVES.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/ALAVES.png
// module id = 2153
// module chunks = 4